/**
 * The bundled curriculum — the seed.
 *
 * `content/mapa.json` is compiled into both bundles and answers until the first revision is
 * published from the world builder; after that the newest stored revision is what students get
 * (see `src/server/content.ts` on the server and `src/ui/store.ts` in the browser). Keeping the
 * file in the bundle is what makes an empty database, an offline client and an unreadable revision
 * all survivable rather than an outage.
 *
 * Parsing happens once and throws on failure: shipping invalid content would strand students
 * mid-island, and the build should not get that far.
 */

import rawContent from '../../content/mapa.json';
import { contentSchema } from './content';
import type { RawContent } from './content';

let parsed: RawContent | null = null;

export function content(): RawContent {
  if (!parsed) {
    const result = contentSchema.safeParse(rawContent);
    if (!result.success) {
      throw new Error(`content/mapa.json is invalid: ${JSON.stringify(result.error.issues[0])}`);
    }
    parsed = result.data;
  }
  return parsed;
}
